import {useEffect, Fragment} from 'react';
import { isValidForNext } from '../createCampaignReducer'
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import { StepConnector } from '@mui/material';
import styles from './CampaignStepper.module.scss';
import { sendEvents } from '../../../utils/events';
import { events } from '../../../utils/constants';
import { useSelector, useDispatch } from 'react-redux';

const CampaignStepper = ({ children, steps, allowedSteps = [], heading, activeStep, setActiveStep, previewCampaign, nextStepValid }) => {
  const dispatch = useDispatch()
  const valid = useSelector(state => state.createCampaign.isValidNext)
  const handleNext = () => {
    if (steps[activeStep] !== allowedSteps[allowedSteps.length - 1]) {
      setActiveStep(activeStep + 1);
      sendEvents(events.BUTTON_CLICK, { button: 'Next', activeStep: activeStep })
    } else {
      previewCampaign(true);
      sendEvents(events.BUTTON_CLICK, { button: 'Preview campaign', activeStep: activeStep })
    }
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
    sendEvents(events.BUTTON_CLICK, { button: 'Previous', activeStep: activeStep })
  };

  const handleReset = () => {
    setActiveStep(0);
    sendEvents(events.BUTTON_CLICK, { button: 'Reset', activeStep: activeStep })
  };

  const handleStepClick = (step, isDisabled) => () => {
    if (!isDisabled && (step < activeStep || ((step === activeStep + 1) && nextStepValid))) {
      setActiveStep(step);
      sendEvents(events.BUTTON_CLICK, { button: 'Step', stepClicked: step, activeStep: activeStep });
    }
  }

  const showPrevious = () => {
    if (allowedSteps.length === 0) {
      return false
    } else if(allowedSteps.length === 1) {
      return false;
    } else if (allowedSteps.length > 1 && allowedSteps.indexOf(steps[activeStep]) === 0) {
      return false;
    } else {
      return true;
    }
  }

  useEffect(()=>{
    dispatch(isValidForNext(nextStepValid))
  },[nextStepValid]) 

  return (
    <Box sx={{ width: '100%', bgcolor: "#FFF", padding: "25px 0px 0px" }}>
      <h1 className={styles.heading}>{heading}</h1>
      <Stepper alternativeLabel sx={{ paddingBottom: "33px" }} connector={<StepConnector classes={{ line: styles.line, active: styles.lineSolid, completed: styles.lineSolid }} />} activeStep={activeStep}>
        {steps.map((step, index) => {
          let stepCursor = "unset"
          let isDisabled = !(allowedSteps.includes(step));
          if (activeStep > index || (nextStepValid && (activeStep + 1 === index))) {
            stepCursor = "pointer"
          }
          const stepProps = {};
          const labelProps = {};

          return (
            <Step 
              key={step}
              {...stepProps}
              completed={!isDisabled && activeStep !== index && activeStep > index }
              active={activeStep === index}
              disabled={isDisabled}
              onClick={handleStepClick(index, isDisabled)}
            >
              <StepLabel
                classes={{
                  active: styles.stepLabelActive,
                  completed: styles.stepLabelActive,
                  disabled: styles.stepLabelDisabled,
                  root: styles.stepLabel,
                }}
                StepIconProps={{
                  sx: {
                    cursor: stepCursor
                  },
                  classes: {
                    active: `${isDisabled ? styles.stepLabelIconDisabled : styles.stepLabelIconActive}`,
                    completed: `${isDisabled ? styles.stepLabelIconDisabled : styles.stepLabelIconActive}`,
                    disabled: styles.stepLabelIconDisabled,
                    root: `${isDisabled ? styles.stepLabelIconDisabled : styles.stepLabelIcon}`
                  }
                }} {...labelProps}>{step}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
      {activeStep === steps.length ? (
        <Fragment>
          <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
            <Box sx={{ flex: '1 1 auto' }} />
            <Button onClick={handleReset}>Reset</Button>
          </Box>
        </Fragment>
      ) : (
        <Fragment>
          <Box sx={{ width: "calc(100% - 52px)", bgcolor: "#E5E5E5" }}>
            {children}
          </Box>
          <Box sx={{ width: "calc(100% - 52px)", bgcolor: "#E5E5E5", display: 'flex', flexDirection: 'row', pt: 2, justifyContent: "end", p: "10px 26px" }}>
            {showPrevious() && <Button
              className={`${styles.buttons} ${styles.prevBtn}`}
              variant='contained'
              color="inherit"
              onClick={handleBack}
              sx={{ mr: 1 }}
            >
              Previous
            </Button>}
            <Button className={styles.buttons} disabled={!valid} variant='contained' sx={{ color: "#FFF" }} onClick={handleNext}>
              {steps[activeStep] !== allowedSteps[allowedSteps.length - 1] ? "Next" : "Preview Campaign"}
            </Button>
          </Box>
        </Fragment>
      )}
    </Box>
  );
}

export default CampaignStepper
